import { Fragment, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { EMPTY_LIST } from '../../../../../constants/common'
import { Checkbox, CHECKBOX_SIZE, CHECKBOX_TYPE } from '../../../../Checkbox'
import { FormModal, formValidationSchemaNoChanged } from '../../../../Form'
import {
  FormikField,
  getFormikCheckboxFieldValueProps,
} from '../../../../Formik'
import {
  isFormCommentsFieldsEqual,
  REQUEST_EDIT_USER_COMMENT_FIELDS_FIELD_NAME_COMMENT,
  REQUEST_EDIT_USER_COMMENT_FIELDS_FIELD_NAME_TEMPLATE,
  REQUEST_EDIT_USER_COMMENT_FIELDS_INITIAL_VALUE,
  REQUEST_EDIT_USER_COMMENT_MODAL_BOX_SIZE,
  REQUEST_EDIT_USER_COMMENT_MODAL_QA_NAME,
  RequestEditUserCommentFields,
} from '../../../RequestEditUserModal'
import {
  CONNECTED_REQUESTS_MASS_EDIT_PARAMETER_FIELD_NAMES,
  QA_NAME_SEND_NOTIFICATION_CHECKBOX,
  QA_NAME_VIEW_COMMENT_BUTTON,
} from '../../ConnectedRequestsMassEditModal.constants'
import { getQaNameConnectedRequestsMassEditElement } from '../../ConnectedRequestsMassEditModal.utils'

import * as styles from '../../ConnectedRequestsMassEditModal.module.css'

function InvitationField({
  commentName,
  commentTemplateName,
  index,
  isCommentName,
  parameter,
  requestId,
}) {
  const { t } = useTranslation()

  const { setFieldValue } = useFormikContext()

  const [modal, setModal] = useState(null)

  const isComment = Boolean(
    parameter?.[CONNECTED_REQUESTS_MASS_EDIT_PARAMETER_FIELD_NAMES.isComment]
  )
  const selectedUsers = Array.isArray(
    parameter?.[CONNECTED_REQUESTS_MASS_EDIT_PARAMETER_FIELD_NAMES.value]
  )
    ? parameter[CONNECTED_REQUESTS_MASS_EDIT_PARAMETER_FIELD_NAMES.value]
    : EMPTY_LIST

  const disabledCheckbox = selectedUsers.length === 0

  function handleCloseModal() {
    setModal(null)
  }

  function handleSaveNoticeValues({ values }) {
    setFieldValue(
      commentName,
      values[REQUEST_EDIT_USER_COMMENT_FIELDS_FIELD_NAME_COMMENT]
    )
    setFieldValue(
      commentTemplateName,
      values[REQUEST_EDIT_USER_COMMENT_FIELDS_FIELD_NAME_TEMPLATE]
    )
    setFieldValue(isCommentName, true)

    handleCloseModal()
  }

  function handleOpenNoticeModal() {
    const initialValues = isComment
      ? {
          [REQUEST_EDIT_USER_COMMENT_FIELDS_FIELD_NAME_COMMENT]:
            parameter?.[
              CONNECTED_REQUESTS_MASS_EDIT_PARAMETER_FIELD_NAMES.comment
            ] ||
            REQUEST_EDIT_USER_COMMENT_FIELDS_INITIAL_VALUE[
              REQUEST_EDIT_USER_COMMENT_FIELDS_FIELD_NAME_COMMENT
            ],
          [REQUEST_EDIT_USER_COMMENT_FIELDS_FIELD_NAME_TEMPLATE]:
            parameter?.[
              CONNECTED_REQUESTS_MASS_EDIT_PARAMETER_FIELD_NAMES.template
            ] ||
            REQUEST_EDIT_USER_COMMENT_FIELDS_INITIAL_VALUE[
              REQUEST_EDIT_USER_COMMENT_FIELDS_FIELD_NAME_TEMPLATE
            ],
        }
      : REQUEST_EDIT_USER_COMMENT_FIELDS_INITIAL_VALUE

    setModal(
      <FormModal
        Fields={RequestEditUserCommentFields}
        containerProps={{
          boxSize: REQUEST_EDIT_USER_COMMENT_MODAL_BOX_SIZE,
          qaName: REQUEST_EDIT_USER_COMMENT_MODAL_QA_NAME,
        }}
        formBodyProps={{
          withNotifications: true,
        }}
        formFieldsProps={{
          id: requestId,
        }}
        formTitle='Modal.SendInvitationTitleKey'
        initialValues={initialValues}
        validationSchema={formValidationSchemaNoChanged({
          initialValues,
          isEqual: isFormCommentsFieldsEqual,
        })}
        onClose={handleCloseModal}
        onSubmit={handleSaveNoticeValues}
      />
    )
  }

  return (
    <>
      <div className={styles.notificationField}>
        <FormikField
          showTooltip
          Component={Checkbox}
          Field={Fragment}
          buttonProps={{
            qaName: getQaNameConnectedRequestsMassEditElement(
              QA_NAME_VIEW_COMMENT_BUTTON,
              index
            ),
            text: t('Modal.TextViewBtnKey'),
            onClick: handleOpenNoticeModal,
          }}
          disabled={disabledCheckbox}
          getValueProps={getFormikCheckboxFieldValueProps}
          label={t('Modal.SendNotificationLabelKey')}
          labelClassName={styles.notificationCheckboxLabel}
          labelTitleClassName={styles.notificationCheckboxLabelTitle}
          name={isCommentName}
          qaName={getQaNameConnectedRequestsMassEditElement(
            QA_NAME_SEND_NOTIFICATION_CHECKBOX,
            index
          )}
          size={CHECKBOX_SIZE.small}
          tooltip={
            disabledCheckbox
              ? t(
                  'Modal.SendNotificationEmptyAssigneesTypeDisabledCheckboxTooltipKey'
                )
              : null
          }
          type={CHECKBOX_TYPE.action}
        />
      </div>
      {modal}
    </>
  )
}

export default InvitationField
